import { AccountBalanceOutlined, AdminPanelSettingsOutlined, BadgeOutlined, BalanceOutlined, FileOpenOutlined, GroupOutlined, HouseOutlined, LocationCityOutlined, OfflineBolt, OfflineBoltOutlined, PaymentOutlined, PersonOutlineOutlined, PriceChangeOutlined, SettingsPowerOutlined, SolarPower } from "@mui/icons-material";

export const navigations = [
    {
        name: "label.menu.home",
        icon: HouseOutlined,
        path: "/home",
        auth: "all",
    },
    {
        name: "label.menu.myData",
        path: "/account/client",
        groups: ["CLIENT", "INDIE_ADMIN", "ENERGY_AGENT_USER"],
        auth: "view_member_area",
        icon: PersonOutlineOutlined,
        type: "extendMenu",
        children: [
            {
                name: "label.menu.profile",
                path: "/account/client/profile/personal-data",
                icon: PersonOutlineOutlined,
            },
            {
                name: "label.menu.paymentsAndReceipts",
                path: "/account/client/payments",
                groups: ["CLIENT"],
                icon: PriceChangeOutlined,
                children: [
                    {
                        name: "label.menu.fiscalData",
                        path: "/account/client/payments/fiscal-data",
                        icon: BadgeOutlined,
                    },
                    {
                        name: "label.title.paymentReceivingMethods",
                        path: "/account/client/payments/payment-receiving-methods",
                        icon: PaymentOutlined,
                    },
                ],
            },
            {
                name: "label.menu.billingAgreements",
                path: "/account/client/invoice-agreements",
                groups: ["CLIENT"],
                icon: BalanceOutlined,
            },
            {
                name: "label.menu.security",
                path: "/account/client/security",
                icon: AdminPanelSettingsOutlined,
            },
            {
                name: "label.step.termsAndConditions",
                path: "/privacy-terms",
                icon: FileOpenOutlined,
            },
            {
                name: "label.menu.faqs",
                handler: () => window.open("https://indie-energy.com/#faqs", "_blank"),
                icon: GroupOutlined,
            },
        ],
    },
    {
        name: "Installations",
        path: "/physical-units/client-physical-units",
        groups: ["CLIENT"],
        auth: "view_member_area",
        client_types: ["producer", "consumer"],
        icon: SolarPower,
    },
    {
        name: "Communities",
        path: "/communities/client-communities",
        groups: ["CLIENT"],
        auth: "view_member_area",
        client_types: ["egac"],
        icon: LocationCityOutlined,
    },
    {
        name: "label.menu.agentAdmin",
        path: "/account/agent",
        groups: ["ENERGY_AGENT_ADMIN"],
        auth: "view_agent_area",
        icon: AdminPanelSettingsOutlined,
    },
    {
        name: "label.menu.saftFiles",
        path: "/saft",
        groups: ["CLIENT"],
        auth: "is_superuser;view_member_area",
        icon: AccountBalanceOutlined,
    },
    {
        name: "Administration",
        icon: AdminPanelSettingsOutlined,
        auth: "is_superuser;add_agent;add_user",
        children: [
            {
                name: "label.title.agents",
                path: "/admin/agents/",
                auth: "add_agent",
            },
            {
                name: "label.title.users",
                path: "/admin/users/",
                auth: "add_user",
            },
            {
                name: "label.title.fileImport",
                path: "/admin/file-import/",
                groups: ["INDIE_ADMIN"],
            },
            /**{
                name: "label.title.entities",
                path: "/entities/",
                auth: "view_mstentities",
            },*/
        ],
    },
    {
        name: "label.menu.clients",
        path: "/clients",
        groups: ["INDIE_ADMIN", "ENERGY_AGENT_ADMIN", "ENERGY_AGENT_USER"],
        auth: "view_mstentities",
        icon: GroupOutlined,
    },
    {
        name: "Communities",
        path: "/communities",
        icon: LocationCityOutlined,
        auth: "view_communities",
    },
    {
        name: "Installations",
        path: "/physical-units/agent-physical-units",
        groups: ["INDIE_ADMIN", "ENERGY_AGENT_ADMIN", "ENERGY_AGENT_USER"],
        auth: "view_physicalunits",
        icon: SolarPower,
    },
    {
        name: "label.menu.tariffsPlans",
        icon: PriceChangeOutlined,
        auth: "view_tariffmodels;view_contracts",
        groups: ["INDIE_ADMIN", "ENERGY_AGENT_ADMIN", "ENERGY_AGENT_USER"],
        children: [
            {
                name: "label.menu.tariffModels",
                path: "/tariff-models",
                auth: "view_tariffmodels",
            },
            {
                name: "label.menu.communities",
                path: "/contracts/communities/",
                auth: "view_contracts",
                groups: ["INDIE_ADMIN", "ENERGY_AGENT_EGAC_USER"],
            },
            {
                name: "label.menu.powertrading",
                path: "/contracts/powertrading/",
                auth: "view_contracts",
                groups: ["INDIE_ADMIN", "ENERGY_AGENT_AGGRTN_USER"],
            },
        ]
    },
    {
        name: "label.menu.energyMarkets",
        icon: OfflineBoltOutlined,
        auth: "view_tradingmarketsessions;view_producers;view_energyfileprocessingrequest",
        children: [
            {
                name: "label.menu.dailyMarkets",
                path: "/markets/dayahead/submit/",
                auth: "view_tradingmarketsessions",
            },
            {
                name: "label.menu.intraDayMarkets",
                path: "/markets/intraday/submit/",
                auth: "view_tradingmarketsessions",
            },
            {
                name: "label.menu.intraDayContinuosMarkets",
                path: "/markets/intraday-continuos/partition/",
                auth: "view_tradingmarketsessions",
            },
            {
                name: "label.menu.market.afrr",
                path: "/markets/bafrr/band/",
                auth: "view_afrrbandoffers",
            },
            {
                name: "label.menu.market.mfrr",
                path: "/markets/mfrr/energy/",
                auth: "view_rensimebidrequestbids",
            },
            {
                name: "market.bilateralContracts",
                path: "/markets/ppa/",
                auth: "view_bilateralcontractcommunications",
            },
            {
                name: "market.unavailabilities",
                path: "/markets/unavailabilities/",
                auth: "view_tradingmarketsessions",
            },
            {
                name: "label.menu.settlements",
                path: "/markets/settlements/energy/",
                auth: "view_tradingmarketsessions",
            },
            {
                name: "label.menu.offerAreas",
                path: "/offering-areas/",
                auth: "view_tradingofferingunits", // TODO: Change the auth Token
            },
            {
                name: "label.menu.offerUnits",
                path: "/offering-units/",
                auth: "view_tradingofferingunits", // TODO: Change the auth Token
            },
            {
                name: "label.menu.marketUnits",
                path: "/market-units/",
                auth: "view_tradingofferingunits",
            },
            {
                name: "label.menu.producers",
                path: "/producers/",
                auth: "view_producers",
            },
            {
                name: "label.menu.dataUpload",
                path: "/data/",
                auth: "view_energyfileprocessingrequest",
            },
        ]
    },
    {
        name: "label.menu.powerManagement",
        icon: SettingsPowerOutlined,
        auth: "view_forecasttypes",
        children: [
            {
                name: "label.menu.forecastTypes",
                path: "/energy-management/forecasts/types/",
                auth: "view_forecasttypes",
            }
        ]
    },
    {
        name: "label.menu.invoicing",
        icon: BalanceOutlined,
        auth: "view_slsinvoices",
        children: [
            {
                name: "label.menu.powertrading",
                path: "/invoicing/powertrading/",
                groups: ["INDIE_ADMIN", "ENERGY_AGENT_AGGRTN_USER"],
                auth: "view_slsinvoices",
            },
            {
                name: "label.menu.communities",
                path: "/invoicing/communities/",
                groups: ["INDIE_ADMIN", "ENERGY_AGENT_EGAC_USER"],
                auth: "view_slsinvoices",
            }
        ]
    },
    {
        name: "Reports",
        icon: FileOpenOutlined,
        auth: "view_reports",
        path: "/reports/",
    }
];